// extracted by mini-css-extract-plugin
module.exports = {"sectionK":"SectionK_sectionK__tODyT"};